const moduleMask = {
    namespaced: true,
	state: {
		VIDEO_MASK_ACTIVE: false,		// 视频遮罩开启状态
		GALLERY_MASK_ACTIVE: false,		// 图片遮罩状态
		VIDEO_URL: '',					// 视频地址
		GALLERY_IMG: '',
		GALLERY_TAG: []
	},
	mutations: {
		SET_VIDEO_MASK_ACTIVE: (state, params) => {		// 设置视频遮罩栏状态
			state.VIDEO_MASK_ACTIVE = params.show
			if(params.videoUrl) {
				state.VIDEO_URL = params.videoUrl
			}
		},
		SET_GALLERY_MASK_ACTIVE: (state, params) => {	// 设置图片遮罩状态
			state.GALLERY_MASK_ACTIVE = params.show
			state.GALLERY_IMG = params.img
			state.GALLERY_TAG = params.tag
		}
	},
	actions: {
	}
}

export default moduleMask
